import React, {useState, useEffect} from 'react';
import Fantum from './FantumGen';
import Button from 'react-bootstrap/Button';
import * as vars from './../vars.js'; import * as subs from './../subs.js';
import * as EVM from './../evm.js';
import { rScoreGivenHash } from './../generate.js'
import { rollName, rollNum, rScore, percentileNum, getObjFromJSONUrl } from './../helpers.js'


function SelectTotGothum(props) {

	var token = props.token;



	
	return (

		<div className="selectFighterFantum" onClick={() => props.onFighterClick()}>

			<div className={"select_gothum_image_left"}>

				<img width={props.rowsize-10} height={props.rowsize-10} src={token.image32} />

			</div>
			<div className={"select_gothum_text_middle"}>

				{token.name}<br/><span className={"select_fantum_text_stats"}>#{token.id}</span>
				
				
			</div>
			<div className={"select_gothum_level_right"}>

				<div className={token.receivedCandy?'':'hidden'}>
					<img src="img/Candy512.png"  width="40" height="40" />
				</div>
				
				
			</div>
			
			
	    	
	    </div>

	);

}

export default SelectTotGothum;